import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-documento-qr',
  templateUrl: './documento-qr.component.html',
  styleUrls: ['./documento-qr.component.css']
})
export class DocumentoQrComponent implements OnInit {

  id:string = '7ba7ec6f-7120-4060-9ce4-55746b6a06cc';
  show:boolean = false;


  constructor(private rutaActiva: ActivatedRoute,) {

    if(this.rutaActiva.snapshot.params.id ==  this.id){
        this.show = true;
    }

  }

  ngOnInit() {




  }

}
